import { GetMsgInfo } from "@/api/clientApi/userKyc.ts";
import { NetFront, NetLogin } from "@/constants/netEvent";
import { reqPost } from "@/service/clientRequest";
import { setMenuStoreStore } from "@/stores/menuStore";
import { upDateUserInfo } from "@/stores/userStore";
import { UserKycAuthActionType } from "@/types/compontent/base/baseEnum.ts";
import {
  AddAccountPwdReq,
  BindDefaultPointTypeReq,
  EditUserInfoReq,
  GetAllLoginSessionsListRsp,
  GetUserPointV2Rsp,
  GetUserRecordReq,
  GetUserRecordRsp,
  GetUserShareUrlReq,
  GetUserShareUrlRsp,
  MyGameListRsp,
  NewBindEmailReq,
  NewBindPhoneReq,
  NewEditPwdReq,
  RemoveLoginDeviceReq,
  UserGameRecordReq,
  UserGameRecordRsp,
} from "@/types/swagger/appserver";
import {
  GetUserInfoByUserIDReq,
  GetUserInfoByUserIDRsp,
  GetUserInfoDetailsRsp,
  GetUserInfoRsp,
  SetUserInfoReq,
  SetUserPrivacySettingReq,
} from "@/types/swagger/front";
import {
  GetFaceAuthCfgByCPFForForgetPwdReq,
  GetFaceAuthCfgByCPFForForgetPwdResp,
} from "@/types/swagger/loginV2.ts";
import { GetFaceAuthCfgByLoginReq } from "@/types/swaggerex/activity";

export async function getUserInfoApi() {
  return reqPost<{}, GetUserInfoRsp>(
    {},
    NetFront.mod,
    NetFront.GetUserInfo,
    true,
  );
  // const res = await reqPost<{}, GetUserInfoRsp>(
  //   {},
  //   NetFront.mod,
  //   NetFront.GetUserInfo,
  //   true,
  // );
  // if (res) {
  //   console.log(need_auth);
  //   console.log(res);
  //   upDateUserInfo(res);
  //   if (need_auth) {
  //     GetMsgInfo({
  //       action_type: UserKycAuthActionType.login
  //     }).then((res) => {
  //       console.log("GetMsgInfo");
  //       console.log(res);
  //     })
  //   }
  // }
  // return res;
}

// 获取用户近期游戏与收藏游戏列表
export async function getRecentGameList() {
  const res_recentGameList = await reqPost<
    Record<string, never>,
    MyGameListRsp
  >({}, NetFront.mod, NetFront.MyGameList, true);
  if (res_recentGameList) {
    setMenuStoreStore("recentGameList", res_recentGameList.recent_gid);
    setMenuStoreStore("collectGameList", res_recentGameList.collect_gid);
  }
  return res_recentGameList;
}
// 用户余额
export const getUserPointV2 = async () => {
  return reqPost<{}, GetUserPointV2Rsp>(
    {},
    NetFront.mod,
    NetFront.GetUserPoint,
    true,
  );
};

//根据用户id获取用户信息
export async function getUserInfoByUserID(data: GetUserInfoByUserIDReq) {
  return await reqPost<GetUserInfoByUserIDReq, GetUserInfoByUserIDRsp>(
    data,
    NetFront.mod,
    NetFront.GetUserInfoByUserID,
    true,
  );
}

// 获取用户信息(settings用)
export async function getUserInfoDetails() {
  return await reqPost<{}, GetUserInfoDetailsRsp>(
    {},
    NetFront.mod,
    NetFront.GetUserInfoDetails,
    true,
  );
}
// 编辑用户资料
export async function EditUserInfo(data: EditUserInfoReq) {
  return await reqPost<EditUserInfoReq, {}>(
    data,
    NetFront.mod,
    NetFront.EditUserInfo,
    true,
  );
}

// 设置用户隐私设置(settings用)
export async function setUserPrivacySetting(data: SetUserPrivacySettingReq) {
  return await reqPost<SetUserPrivacySettingReq, {}>(
    data,
    NetFront.mod,
    NetFront.SetUserPrivacySetting,
    true,
  );
}

// 设置用户联系方式
export async function setUserInfos(data: SetUserInfoReq) {
  return await reqPost<SetUserInfoReq, {}>(
    data,
    NetFront.mod,
    NetFront.SetUserInfo,
    true,
  );
}

// 设置用户联系方式
export async function SaveUserIdentifys(data: SetUserInfoReq) {
  return await reqPost<SetUserInfoReq, {}>(
    data,
    NetFront.mod,
    NetFront.SaveUserIdentifys,
    true,
  );
}

// 设置用户联系方式
export async function useBindDefaultPointType(data: BindDefaultPointTypeReq) {
  return await reqPost<BindDefaultPointTypeReq, {}>(
    data,
    NetFront.mod,
    NetFront.BindDefaultPointType,
    true,
  );
}

//修改密码
export async function changePassword(data: NewEditPwdReq) {
  return await reqPost<NewEditPwdReq, {}>(
    data,
    NetLogin.mod,
    NetLogin.NewEditAccountPwd,
    true,
  );
}
// CPF重置密码
export async function GetFaceAuthCfgByCPFForForgetPwd(
  data: GetFaceAuthCfgByCPFForForgetPwdReq,
) {
  return reqPost<
    GetFaceAuthCfgByCPFForForgetPwdReq,
    GetFaceAuthCfgByCPFForForgetPwdResp
  >(data, NetLogin.mod, NetLogin.GetFaceAuthCfgByCPFForForgetPwd, false);
}

// CPF重置密码
export async function GetFaceAuthCfgByLogin(data: GetFaceAuthCfgByLoginReq) {
  return reqPost<GetFaceAuthCfgByLoginReq, GetFaceAuthCfgByCPFForForgetPwdResp>(
    data,
    NetLogin.mod,
    NetLogin.GetFaceAuthCfgByLogin,
    false,
  );
}

//新用户添加密码
export async function addNewUserPassword(data: AddAccountPwdReq) {
  return await reqPost<AddAccountPwdReq, {}>(
    data,
    NetLogin.mod,
    NetLogin.AddAccountPwd,
    true,
  );
}
//获取分享代理链接
export async function useGetUserShareUrl(data: GetUserShareUrlReq) {
  return await reqPost<GetUserShareUrlReq, GetUserShareUrlRsp>(
    data,
    NetFront.mod,
    NetFront.GetUserShareUrl,
    true,
    () => {},
    () => {},
    { forceRefresh: true },
  );
}
// 获取用户投注记录
export async function getUserBetRecord(data: UserGameRecordReq) {
  return await reqPost<UserGameRecordReq, UserGameRecordRsp>(
    data,
    NetFront.mod,
    NetFront.GetGameRecord,
    true,
  );
}

// 获取用户交易记录
export async function getUserTransactionRecord(data: GetUserRecordReq) {
  return await reqPost<GetUserRecordReq, GetUserRecordRsp>(
    data,
    NetFront.mod,
    NetFront.GetUserRecord,
    true,
  );
}

// 新增用户安全邮箱
export async function addNewSecurityEmail(data: NewBindEmailReq) {
  return await reqPost<NewBindEmailReq, {}>(
    data,
    NetLogin.mod,
    NetLogin.NewBindEmail,
    true,
  );
}

// 新增用户安全手机号
export async function addNewSecurityPhone(data: NewBindPhoneReq) {
  console.log("addNewSecurityPhone", data);
  return await reqPost<NewBindPhoneReq, {}>(
    data,
    NetLogin.mod,
    NetLogin.NewBindPhone,
    true,
  );
}

// 获取所有登录设备会话列表
export async function getAllLoginSessionsList() {
  return await reqPost<{}, GetAllLoginSessionsListRsp>(
    {},
    NetFront.mod,
    NetFront.GetAllLoginSessionsList,
    true,
  );
}

// 移除登录设备
export async function removeLoginDevice(data: RemoveLoginDeviceReq) {
  return await reqPost<RemoveLoginDeviceReq, {}>(
    data,
    NetFront.mod,
    NetFront.RemoveLoginDevice,
    true,
  );
}

//
export async function CheckAndPopupUserInfoCollection(data: {}) {
  return reqPost<{}, {}>(
    data,
    NetFront.mod,
    NetFront.CheckAndPopupUserInfoCollection,
    true,
  );
}
